import { defineComponent, ref } from 'vue'
import CityMapView, { CityMapViewProp } from './CityMapView'
import renderCompsList from './renderCompsList'

// 组件拼装
export default defineComponent({
  name: 'map-index',
  props: [],
  setup: () => {
    const cityMapViewRef = ref<CityMapViewProp>()
    const readyFn = () => {
      console.log('====================================')
      console.log('地图组件加载完成readyFn')
      console.log('====================================')
      cityMapViewRef.value?.renderComps(renderCompsList)
    }
    return () => <CityMapView ref={cityMapViewRef} onReady={readyFn}></CityMapView>
  },
})
